import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../../httpClient/RestApiService';

function getPublishViewsToSalesforceConfig(): JsonRestApiRequestConfig {
  return {
    restApiVersion: 'exp',
    httpMethod: 'POST',
    endpoint: 'publishViewsToSalesforce',
  };
}

export type publishToSalesforceRequest = {
  readonly publishToSalesforce: {
    readonly viewLuids: string[];
    readonly salesforceAppId: string;
    readonly oauthId: string;
  };
}

export interface IPublishToSalesforceResponse {
  readonly publishToSalesforce: {
    readonly hasErrors: boolean;
    readonly salesforceAppUrl: string;
    readonly publishToSalesforceInfo: IPublishToSalesforceInfo[];
  };
}

export interface IPublishToSalesforceInfo {
  readonly viewLuid: string;
  readonly statusCode: string;
  readonly message: string;
}

export interface IParsedPublishToSalesforceResponse {
  appName: string;
  numSuccesses: number;
  numFailures: number;
  failureNames?: string[];
  successName?: string;
  successAction?: () => void;
}

export class PublishToSalesforceService {
  public static callViaApiService(request: publishToSalesforceRequest) {
    return makeJsonRestApiRequest<publishToSalesforceRequest, IPublishToSalesforceResponse>({
      config: getPublishViewsToSalesforceConfig(),
      request
    });
  }
}